import requisicaoData from './requisicao.json';

/**
 * Retorna as categorias com os itens devidamente ordenados pelo atributo 'ordem'
 */
export const getExamesPorCategoria = () => {
  return requisicaoData.requisicao.map((categoria) => ({
    ...categoria,
    items: [...categoria.items].sort((a, b) => (a.ordem || 0) - (b.ordem || 0)),
  }));
};

export const buscarExame = (nomeExame) => {
  const nome = nomeExame.toLowerCase().trim();

  for (const categoria of requisicaoData.requisicao) {
    for (const item of categoria.items) {
      if (item.nome.toLowerCase() === nome) {
        return { ...item, categoria: categoria.categoria };
      }
    }
  }

  // Retorna padrão se não encontrar
  return {
    nome: nomeExame,
    tuss: null,
    categoria: 'Outros Exames',
    ordem: 999, // Posição padrão ao final caso o exame seja dinâmico/não mapeado
  };
};

/**
 * Formata um exame para adicionar à requisição (formato simples com número)
 */
export const formatarExameParaRequisicao = (exame, numeroRequisicao) => {
  const tussInfo = exame.tuss ? ` [${exame.tuss}]` : '';
  const linhas = [`${numeroRequisicao} - ${exame.nome}${tussInfo}`, ''];
  return linhas.join('\n');
};

/**
 * Formata a lista inteira de exames mantendo a ordem do json (atributo 'ordem'),
 * mesmo ao adicionar, remover ou editar.
 *
 * @param {Array} examesSelecionados - Lista de objetos de exames selecionados
 * @param {string} textoAtual - Texto da requisição (preserva metadados de cabeçalho como CONVÊNIO, NOME, CID, INDICAÇÃO)
 * @returns {string} Texto formatado com os exames na ordem correta
 */
export const reordenarEFormatarTextoRequisicao = (examesSelecionados, textoAtual = '') => {
  const categoriaHeader = 'EXAMES:';

  // Extrai o cabeçalho original da requisição (Convenio, Nome, CID, Indicação, etc)
  let cabecalho = textoAtual;
  if (textoAtual.includes(categoriaHeader)) {
    cabecalho = textoAtual.split(categoriaHeader)[0].trimEnd();
  } else {
    cabecalho = textoAtual.trimEnd();
  }

  if (!examesSelecionados || examesSelecionados.length === 0) {
    return cabecalho ? `${cabecalho}\n` : '';
  }

  // Ordena os exames selecionados estritamente pelo atributo 'ordem'
  const examesOrdenados = [...examesSelecionados].sort((a, b) => (a.ordem || 0) - (b.ordem || 0));

  // Monta o bloco formatado de exames
  const linhasExames = examesOrdenados.map((exame) => `  - ${exame.nome}`);
  const blocoExames = `${categoriaHeader}\n${linhasExames.join('\n')}\n`;

  return cabecalho ? `${cabecalho}\n\n${blocoExames}` : blocoExames;
};

/**
 * Formata um exame com categoria como título e item com marcador (Mantido para retrocompatibilidade)
 */
export const formatarExameComCategoria = (exame, textoAtual) => {
  const categoriaHeader = 'EXAMES:';
  const itemExame = `   - ${exame.nome}`;

  if (textoAtual.includes(categoriaHeader)) {
    const linhas = textoAtual.split('\n');
    const indexCategoria = linhas.findIndex((l) => l.includes(categoriaHeader));

    if (indexCategoria !== -1) {
      let indexInsercao = indexCategoria + 1;
      while (
        indexInsercao < linhas.length &&
        (linhas[indexInsercao].trim().startsWith('-') || linhas[indexInsercao].trim() === '')
      ) {
        if (linhas[indexInsercao].trim() === '' && indexInsercao > indexCategoria + 1) {
          break;
        }
        indexInsercao += 1;
      }

      linhas.splice(indexInsercao, 0, itemExame);
      return {
        novoTexto: linhas.join('\n'),
        categoriaAdicionada: false,
      };
    }
  }

  const novaSecao = `${categoriaHeader}\n${itemExame}\n`;
  return {
    novoTexto: textoAtual + novaSecao,
    categoriaAdicionada: true,
  };
};

export const adicionarExameATexto = (exame, numeroRequisicao = 1) => {
  const tussInfo = exame.tuss ? ` [${exame.tuss}]` : '';
  return `${numeroRequisicao} - ${exame.nome}${tussInfo}\n`;
};
